import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { FormRow, Col } from '../../../../../../1stlog-ui/src/components/Bootstrap'
import { useField, FeedbackBadge } from '../../../../../../1stlog-ui/src/components/Field'

const validate = (value) => value

const TotalWeightValidation = (props) => {
  const {} = props

  const {
    input: { value: isTotalWeightInvalid, onChange: setIsTotalWeightInvalid },
    meta
  } = useField('customsValidation.isTotalWeightInvalid', {
    raw: true,
    validate,
    subscribeAll: true
  })

  const colis = useField('colis')

  const customs = useField('customs')

  useEffect(() => {
    const totalColiWeight = lodash.sum(
      lodash.map(colis, (coli) => parseFloat(lodash.get(coli, 'weight')))
    )
    const totalCustomsWeight = lodash.sum(
      lodash.map(customs, ({ netWeight, count }) => parseFloat(netWeight) * parseFloat(count) || 0)
    )
    const newIsTotalWeightValid =
      totalColiWeight < totalCustomsWeight
        ? i18n.t(
            'error_customMustEqualTotalOrderWeigth',
            'Das Gesamtgewicht Ihrer Zollprodukte muss dem Gesamtgewicht der gebuchten Produkte entsprechen'
          )
        : undefined
    if (!lodash.isEqual(isTotalWeightInvalid, newIsTotalWeightValid)) {
      setIsTotalWeightInvalid(newIsTotalWeightValid)
    }
  }, [colis, customs])

  return (
    isTotalWeightInvalid && (
      <FormRow>
        <Col>
          <FeedbackBadge meta={meta} />
        </Col>
      </FormRow>
    )
  )
}

export default TotalWeightValidation
